import { formatTranslation } from '@/core/oddsApi/helpers/formatTranslation';
import type { OutrightTournamentTypeEuroFragment, OutrightTournamentTypeFragment } from '@/core/oddsApi/oddsApiType';
import type { IOutrightLeague, IOutrightLeagueEuro } from '@/interface/IOutrightLeague';
import type { SportType } from '@/interface/enum';
import { LeagueSize } from '@/interface/enum';

export function formatOutrightLeague(
    item: OutrightTournamentTypeFragment,
    sportType: SportType,
    isLive: boolean,
): IOutrightLeague {
    const { tournament, eventDate, oddsCount } = item;
    return {
        id: tournament.id,
        name: tournament.tournamentName.map(x => formatTranslation(x)),
        info: tournament.tournamentInfo.map(x => formatTranslation(x)),
        leagueCode: tournament.tournamentCode,
        size: LeagueSize.fromOddsApi(tournament.tournamentSize),
        eventDate,
        sportType,
        isLive,
        oddsCount,
    };
}

export function formatOutrightLeagueEuro(
    item: OutrightTournamentTypeEuroFragment,
    sportType: SportType,
): IOutrightLeagueEuro {
    const { tournament, eventDate, oddsCount, isLive } = item;
    return {
        id: tournament.id,
        name: tournament.tournamentName.map(x => formatTranslation(x)),
        info: tournament.tournamentInfo.map(x => formatTranslation(x)),
        leagueCode: tournament.tournamentCode,
        size: LeagueSize.fromOddsApi(tournament.tournamentSize),
        eventDate,
        sportType,
        isLive,
        oddsCount,
    };
}
